import styled, { css } from 'styled-components';
import { theme } from '../../../theme';

export const SpanLabel = styled.span`
  margin-left: 0.769rem;
`;

const indeterminate = css`
  width: 9px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid ${theme.colors.active};
`;

const base = css`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  width: 5px;
  height: 10px;
  border: solid ${theme.colors.active};
  border-width: 0 2px 2px 0;
`;

export const SpanCheckMark = styled.span<{ indeterminate: number }>`
  position: relative;
  top: 0;
  left: 0;
  background-color: transparent;
  min-height: 1.385rem;
  min-width: 1.385rem;
  border: 1px solid ${theme.colors.textDisabled};

  &::after {
    content: '';
    position: absolute;
    display: none;
    ${(props) => (props.indeterminate ? indeterminate : base)}
  }
`;

export const LabelContainer = styled.label`
  display: flex;
  align-items: flex-start;
  position: relative;
  margin: 0;
  cursor: pointer;
  user-select: none;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.538rem;
  color: ${theme.colors.textPrimary};

  &.active,
  &.indeterminate {
    ${SpanCheckMark} {
      border: 1px solid ${theme.colors.active};

      &::after {
        display: block;
      }
    }
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  &.disabled {
    opacity: 0.25;
    cursor: default;
  }
`;
